var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Sales by Date",
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "mr-3" },
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("Start Date:"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.startDate) + "\n            "
                          ),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onStartDateChanged },
                            model: {
                              value: _vm.filters.start_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "start_date", $$v)
                              },
                              expression: "filters.start_date",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("End Date:"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.endDate) + "\n            "),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onEndDateChanged },
                            model: {
                              value: _vm.filters.end_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "end_date", $$v)
                              },
                              expression: "filters.end_date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Download CSV",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reset Filters",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.resetFilters.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-counterclockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "header-right",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "mt-n2 d-flex flex-wrap" },
                    [
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.categoryTypes },
                        on: { change: () => _vm.loadReportData() },
                        model: {
                          value: _vm.filters.category_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "category_type", $$v)
                          },
                          expression: "filters.category_type",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.categories },
                        on: { change: () => _vm.loadReportData() },
                        model: {
                          value: _vm.filters.category,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "category", $$v)
                          },
                          expression: "filters.category",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.productionTypes },
                        on: { change: () => _vm.loadReportData() },
                        model: {
                          value: _vm.filters.production_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "production_type", $$v)
                          },
                          expression: "filters.production_type",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.strainTypes },
                        on: { change: () => _vm.loadReportData() },
                        model: {
                          value: _vm.filters.strain_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "strain_type", $$v)
                          },
                          expression: "filters.strain_type",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-select", {
                        staticClass: "w-auto my-2",
                        attrs: { options: _vm.promoted_filter_options },
                        on: { change: () => _vm.loadReportData() },
                        model: {
                          value: _vm.filters.is_promoted,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "is_promoted", $$v)
                          },
                          expression: "filters.is_promoted",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }